import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import styles from "@/styles/article/return-policy.module.scss"
import Link from 'next/link'
export default function WarrantyPolicy() {

  return (
    <>
      <Head>
        <title>
          Online Shopping New Zealand - Beauty & Health, Computers, Toys, - Deals & Discounts | BestDeals
        </title>
        <meta
          name="keywords"
          content=""
        ></meta>
        <meta
          name="description"
          content="Offers the best online shopping in New Zealand with cheap deals on home & garden, appliances, pet supplies, fitness equipment & much more online. Check out our daily sales now!"
        ></meta>
      </Head>

      <DefaultLayout >
        <div className={`${styles['page-return-policy']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles['content']}>
            <div className={styles['content-title']}>Warranty Policy</div>

            <div className={`${styles['ask-title']}`}>Making a Warranty Claim</div>
            <div className={styles['answer-desc']}>
              {`To make a warranty claim you must`}
            </div>
            <div className={styles['answer-desc']}>
              {`• provide us with a copy of your tax invoice or similar proof that the product or products was or were purchased from us via this website; and`}
            </div>
            <div className={styles['answer-desc']}>
              {`• describe accurately the problem you have encountered and provide evidence (e.g. a photograph) to support your claim; and`}
            </div>
            <div className={styles['answer-desc']}>
              {`• state whether you are requesting a replacement, repair, refund or credit.`}
            </div>
            <div className={styles['answer-desc']}>
              {`If your use of this website or its content is subject to the Consumer Guarantees Act 1993 ("CGA"), you may have rights or remedies that are not excluded nor limited by the above. If you are using this site or its content for business purposes, the above exclusions and limitations will apply and the CGA will not apply.`}
            </div>


            <div className={`${styles['ask-title']} padding-top-14`}>Return of Product for Warranty Claim</div>
            <div className={styles['answer-desc']}>
              {`Where the 30 Days Change-of-Mind period has elapsed and where we have determined that, on the facts you have provided, a claim may be granted. We will not accept the return of a product without our approval except within the period of 30 Days Change-of-Mind period. Where possible, the product or products must be packed in the original and unmarked packaging including any accessories, manuals, documentation and registration that was delivered with the product or products.`}
            </div>
            <div className={styles['answer-desc']}>
              {`We will send you contact details of our courier to organize pick up from the original delivery address for authorised returns.`}
            </div>
            <div className={styles['answer-desc']}>
              {`We reserve the right to test any returned product and require you to demonstrate that the problem with the product was not your making or fault. After the product has been returned a final decision on granting the claim will be made by Customer Services.`}
            </div>
            <div className={styles['answer-desc']}>
              {`Where it is agreed that the claim is valid a replacement or repaired product will be returned to you at our expense. Where upon receipt of the returned product we determine that the product did comply with the warranties and conditions and the condition of the product was misrepresented to us by you, the expense for the return of the product to us and the expense of returning the product back to you will be deducted from your account or charged to you together with an additional $30.00 handling and administration fee.`}
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>The BestDeals 30 Day Change-of-Mind Policy</div>
            <div className={styles['answer-desc']}>
              {`Online shopping sometimes means you don't get exactly what you had in mind. You are welcome to return the item as long as you meet the following terms and conditions as listed below:`}
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>Terms & Conditions</div>
            <div className={styles['answer-desc']}>
              <p>{`1.Item to be returned must be in their original re-saleable condition with all tags and packaging (ready to be put back on the shelf).`}</p>
              <p>{`2.The item/s are NOT opened, used, worn or damaged.`}</p>
              <p>{`3.That you DO NOT stick or write anything on the item itself or its packaging. Please only write or place postage stickers on the outer postage packaging.`}</p>
              <p>{`4.Some items are not eligible for refund due to hygienic reasons.`}</p>
              <p>{`5.The refund amount will not include delivery costs. If the item was delivered for free, delivery cost will be deducted.`}</p>
              <p>{`6.Handling fees will apply at 20% of the purchase price.`}</p>
              <p>{`7.The return of the item is the responsibility of the buyer.`}</p>
              <p>{`8.If the item has sustained damage in transit or does not return as noted above, a revised refund amount may be required`}</p>
              <p>{`9.If you would like to take this offer, please send us an email at and indicate the Order ID the item/s you wish to return and the reason for the return. Our Customer Service team will reply to your email and, if applicable, issue you a Return Authorization (RA) number. All other relevant information will be given to you at this time. BestDeals will not accept any return of any item/s without an RA from our Customer Service Representative.`}</p>
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>Limitation of Liability</div>
            <div className={styles['answer-desc']}>
              {`(a) Our liability to the Customer (and any party claiming through the Customer against us) for any claim for loss or damages (including legal expenses) made in connection with the Contract (including the supply of Goods described in the Contract) whether in contract, tort (including negligence), under statute, in equity or otherwise shall be strictly limited as follows (except to the extent that the law prohibits such a limitation):`}
            </div>
            <div className={styles['answer-desc']}>
              {`(i) for any liability arising from Goods not meeting the specification or which are said to be otherwise defective or deficient, our liability is limited to the cost of replacement of those Goods as soon as reasonably practicable, or the repair of those Goods or the repayment (or allowance) of the Purchase Price of those Goods (at the option of Our);`}
            </div>
            <div className={styles['answer-desc']}>
              {`(ii) for any liability arising from the services forming part of the Goods not meeting the scope`}
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>Consequential Loss</div>
            <div className={styles['answer-desc']}>
              {`(a) We may hold the Customer liable, to the maximum extent permitted by law, for any indirect, special or consequential loss or damage of any nature whatsoever resulting from or caused in any way by the Goods it supplies, where indirect, special or consequential loss or damage includes:`}
            </div>
            <div className={styles['answer-desc']}>
              (i) any loss of income, profit, production, contract, customers, business opportunity or business;
            </div>
            <div className={styles['answer-desc']}>
              (ii) any loss of goodwill or reputation;
            </div>
            <div className={styles['answer-desc']}>
              (iii) any loss or damage resulting from the loss or damage to goods other than the Goods.
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>Defective Goods</div>
            <div className={styles['answer-desc']}>
              (a) Any claim by the Customer in respect of defective, non-conforming or damaged Goods must be made in writing within 14 days of the delivery of the Goods, unless a longer period is expressly agreed to by us in writing.
            </div>
            <div className={styles['answer-desc']}>
              (b) Despite any other provision of the Contract, we are not liable, to the maximum extent permitted by law, for:
            </div>
            <div className={styles['answer-desc']}>
              (i) the cost of removal of Goods not meeting the specification or which are said to be otherwise defective or deficient, whether installed or otherwise;
            </div>
            <div className={styles['answer-desc']}>
              (ii) the cost of installation of replacements for Goods not meeting the specification or which are said to be otherwise defective or deficient;
            </div>
            <div className={styles['answer-desc']}>
              (iii) defects or deficiencies in Goods caused by improper installation or maintenance of Goods or related components or normal wear and tear and damage.
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}